import DataList from './../data/staticData.js'

const GeneralHelper = {
    convertFrequencyLabel: val => {
        return DataList.dateFrequencies.find(a => a.value === val)?.label ?? '';
    }
}

export default GeneralHelper;